import { HIGHLIGHT_COLOR } from "../shared/constants"
import type {
  BoundaryRect,
  BoundarySide,
  HdRoute,
  VisualizationFrame,
} from "../shared/types"
import { createSideStripRect } from "./createSideStripRect"

export const createSideAnalysisFrame = (
  routes: HdRoute[],
  boundary: BoundaryRect,
  side: BoundarySide,
  margin: number,
  moveAmount: number,
  hasObstacle: boolean,
): VisualizationFrame => ({
  title: `${side} boundary analysis: move=${moveAmount.toFixed(3)} (${hasObstacle ? "obstacle-side" : "clear-side"})`,
  routes,
  activeSide: side,
  overlayRects: [
    createSideStripRect(
      boundary,
      side,
      margin,
      HIGHLIGHT_COLOR,
      `strip:${side}`,
    ),
  ],
})
